<template>
    <div class="DateQuestion LineInputBlock">
        <span v-if="!bare">
            {{ question.metadata.description }}
        </span>
        <DatePicker
            v-model="inputValue"
            :value-format="field.format"
            :display-format="displayFormat"
            :min-date="field.minDate"
            @update:model-value="change"
        />
    </div>
</template>

<script lang="ts">
    import { Component, Watch } from 'vue-property-decorator';

    import { localeDateInputFormat } from '@evidentid/ido-lib/formatLocaleDate';

    import DatePicker from '@/components/forms/DatePicker.vue';
    import FieldComponent from '@/fields/FieldComponent';

    @Component({
        emits: [ 'change' ],
        components: { DatePicker },
    })
    export default class Date extends FieldComponent<string> {
        private inputValue = this.value || '';

        // Only what the field SHOWS follows the viewer's locale. `field.format` still
        // governs the value that is submitted, so the payload and the field validators
        // that parse it are unaffected by where the person happens to be.
        private get displayFormat(): string {
            return localeDateInputFormat();
        }

        @Watch('value')
        private onValueChange(value: string) {
            this.inputValue = value;
        }

        private change() {
            this.$emit('change', this.inputValue);
        }
    }
</script>
